import React from 'react'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { ShowIf } from '@ztechapps/webui.util'

type HoverEditButtonProps = { onClick: () => void; canEdit: boolean; className?: string }

/** The row's hover "Edit" link. `className` (its slot's visibility, `HoverEditCodeLinks`'s local
 * CSS module) is the caller's, not `HoverMenuContainer`'s shared `display: none` — this component
 * has no other caller today. */
export const HoverEditButton = ({ onClick, canEdit, className }: HoverEditButtonProps) => {
  return (
    <ShowIf condition={canEdit}>
      <div className={className}>
        <BusyButtonLink text="Edit" onClick={onClick} icon="edit" disabled={!canEdit} className="text-nowrap" />
      </div>
    </ShowIf>
  )
}
